<template>
    <div class="w-full">
        <v-select v-model="selection" class="style-chooser" :placeholder="placeholder" :options="options" :multiple="multiple" :close-on-select="!multiple" :clear-search-on-select="!multiple" :clearable="clearable" @input="handleSelect" @change="handleSelect">
            <div slot="no-options">Ingen valgmuligheter</div>
        </v-select>
    </div>
</template>

<script>
    import LOpenIndicator from "./LOpenIndicator";
    import LDeselect from "./LDeselect";
    import vSelect from "vue-select";
    vSelect.props.components.default = () => ({
        Deselect: LDeselect,
        OpenIndicator: LOpenIndicator
    });

    export default {
        name: "LSelect2",
        components: { vSelect },
        props: ["value", "placeholder", "multiple", "options", "clearable"],
        data() {
            return {
                selection: this.value
            };
        },
        methods: {
            handleSelect: function (val) {
                if (!this.multiple) {
                    let emitVal = val;
                    if (val && typeof val === 'object' && val.value !== undefined) {
                        emitVal = val.value;
                    }
                    this.selection = val;
                    this.$emit("input", emitVal);
                    this.$emit("change", emitVal);
                    //console.log('single', emitVal);
                } else {
                    this.selection = val;
                    this.$emit("input", val);
                    this.$emit("change", val);
                }
            },
            findOptionById: function (id) {
                return this.options.find(option => option.value === id);
            }
        },
        watch: {
            value: {
                handler(val) {
                    if (typeof val === 'string' || typeof val === 'number') {
                        const matchedOption = this.findOptionById(val);
                        if (matchedOption) {
                            this.selection = matchedOption;
                        } else {
                            this.selection = val;
                        }                    
                    } else {
                        this.selection = val;
                    }
                },
                immediate: true
            },
            //selection: function (val) {
            //    this.$emit("input", val);
            //}
        }
    };
</script>

<style src="vue-select/dist/vue-select.css"></style>
<style lang="postcss">
    .style-chooser .vs__search::placeholder,
    .style-chooser .vs__dropdown-toggle,
    .style-chooser .vs__dropdown-menu {
        @apply text-bluegray-300;
    }

    .style-chooser .vs__dropdown-option {
        @apply text-bluegray-300;
    }

    .style-chooser .vs__dropdown-option--highlight {
        @apply bg-pastel-green-500 text-white;
    }

    .style-chooser .vs__clear,
    .style-chooser .vs__open-indicator {
        @apply text-gray-500;
    }

    .style-chooser .vs__deselect {
        @apply text-gray-500 text-xs;
    }

    .l-select-disabled .vs__dropdown-toggle {
        background-color: #f3f3f3;
    }
</style>
